// @flow

import React from "react";
import { connect } from "react-redux";

import { pubsub } from "@utils";
import Button from "@components/atoms/Button";

type PropsType = {
    className?: string,
    session: any,
    adyen: any
};

// Add adyenCheckoutRef as a prop
const CheckoutSubmitButton = (props: PropsType & { adyenCheckoutRef?: any }): any => {
    if (props.session.paymentMethodName === "PayPal") return null;
    return (
        <Button
            className="button--pay"
            styleType="green"
            onClick={(e: any): any => {
                // If AdyenCheckout ref is available, trigger Adyen validation
                if (props.adyenCheckoutRef && props.adyenCheckoutRef.current) {
                    props.adyenCheckoutRef.current.submit();
                } else {
                    pubsub.publish("CHECKOUT_FORM_SUBMIT");
                }
            }}
        >
            <i className="button__lock-icon icon icon-lock-with-hole"></i>
            Confirm and pay now
        </Button>
    );
};

const mapStateToProps = (state: any): any => {
    return {
        session: state.session,
        adyen: state.adyen
    };
};

const mapDispatchToProps = {};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CheckoutSubmitButton);
